import { render, staticRenderFns } from "./popup-category-item-do.vue?vue&type=template&id=06f00056&scoped=true"
import script from "./popup-category-item-do.vue?vue&type=script&lang=js"
export * from "./popup-category-item-do.vue?vue&type=script&lang=js"
import style0 from "./popup-category-item-do.vue?vue&type=style&index=0&id=06f00056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f00056",
  null
  
)

export default component.exports